import SwipeableCard from './SwipeableCard';

const RecommendationCards = ({ recommendations, onRecommendationClick, onSwipeLeft }) => {

  if (!recommendations?.length) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4 md:gap-6">
      {recommendations.map((recommendation) => {
        const { id, name, description } = recommendation;
        const handleActivate = () => {
          if (typeof onRecommendationClick === 'function') {
            onRecommendationClick(recommendation);
          }
        };

        return (
          <SwipeableCard
            key={id}
            onSwipeLeft={() => {
              if (typeof onSwipeLeft === 'function') {
                onSwipeLeft(id);
              }
            }}
            onClick={handleActivate}
          >
            <div
              role="button"
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  handleActivate();
                }
              }}
              className="bg-white rounded-2xl border border-gray-100 shadow-md p-4 md:p-6 flex flex-col justify-between min-h-[112px] cursor-pointer overflow-hidden transition-all duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-400 hover:shadow-lg hover:-translate-y-0.5 active:scale-[0.98]"
            >
              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-1">
                {name}
              </h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                {description}
              </p>
            </div>
          </SwipeableCard>
        );
      })}
    </div>
  );
};

export default RecommendationCards;

